global.API = 'https://c71.cryptotrade1.com/';
global.blogAPI = 'https://blog.cryptotrade1.com/';